export const MenuIdItam = 'ITAM' as const;
